import React from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';

const MultiLineText = ({ children }) => {
	const lines = children.split('\n');
	return (
		<>
			{lines.map((text, index) => {
				const id = uniqueId('line_');
				return (
					<React.Fragment key={id}>
						{text}
						{(index < lines.length - 1) && <br />}
					</React.Fragment>
				)
			})}
		</>
	);
}

MultiLineText.propTypes = {
	children: PropTypes.string,
}

MultiLineText.defaultProps = {
	children: '',
}

export default MultiLineText;
